import { CookieService } from 'ngx-cookie';
import * as jwt_decode from 'jwt-decode';
import { BehaviorSubject } from 'rxjs';
import { THIRTY_DAYS_IN_MS } from './preferences.service';
var CredentialsService = /** @class */ (function () {
    function CredentialsService(_cookieService) {
        this._cookieService = _cookieService;
        this.ACCESS_TOKEN_COOKIE = 'dca_at';
        this.ACCESS_TOKEN_COOKIE_EXP = 'dca_at_exp';
        this.REMEMBER_ME = 'dca_remember';
        this._requestedPathPreLogin = null;
        this._isLoggedInSubject = new BehaviorSubject(false);
    }
    Object.defineProperty(CredentialsService.prototype, "isLoggedIn", {
        /**
         * Observable to components to monitor if a user is logged in or not.
         */
        get: function () {
            return this._isLoggedInSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the path that was requested prior to login. Null if no path requested.
     */
    CredentialsService.prototype.getRequestedPathPreLogin = function () {
        return this._requestedPathPreLogin;
    };
    CredentialsService.prototype.setRequestedPathPriorToLogin = function (path) {
        this._requestedPathPreLogin = path;
    };
    /**
     * Gets the access token as long as it is available and not expired, otherwise returns null
     */
    CredentialsService.prototype.getAccessToken = function () {
        if (!this._accessToken) {
            this._accessToken = this._cookieService.get(this.ACCESS_TOKEN_COOKIE);
            var exp = this._cookieService.get(this.ACCESS_TOKEN_COOKIE_EXP);
            this._expiryTime = exp ? parseInt(exp) : 0;
        }
        var now = Date.now();
        if (now > this._expiryTime) {
            return null;
        }
        return this._accessToken;
    };
    /**
     * Checks if the current access token is valid, ie is the user logged in.
     */
    CredentialsService.prototype.isAccessTokenValid = function () {
        if (this.getAccessToken() != null) {
            // They are logged in, broadcast that to anyone who cares.
            this._isLoggedInSubject.next(true);
            return true;
        }
        return false;
    };
    /**
     * If the access token is valid, decoded it and pull out the email address.
     */
    CredentialsService.prototype.getEmailFromAccessToken = function () {
        var accessToken = this.getAccessToken();
        if (accessToken) {
            var decoded = jwt_decode(accessToken);
            return decoded.user_email;
        }
        return null;
    };
    /**
     *
     * @param accessToken The access token
     * @param expiresInSeconds The expiry time in seconds of token
     * @param rememberMe If the token should be a long expiry cookie or a session cookie. If null, we should base it off of the RMEMBER_ME cookie.
     */
    CredentialsService.prototype.setTokens = function (accessToken, expiresInSeconds, rememberMe) {
        this._accessToken = accessToken;
        var now = Date.now();
        now = now + (expiresInSeconds * 1000);
        this._expiryTime = now;
        if (rememberMe === null) {
            // Get it from the cookie
            var rememberMeCookie = this._cookieService.get(this.REMEMBER_ME);
            rememberMe = rememberMeCookie === '1';
        }
        if (rememberMe) {
            // Store cookies good for a month
            var expireDate = new Date(Date.now() + THIRTY_DAYS_IN_MS);
            this._cookieService.put(this.ACCESS_TOKEN_COOKIE, accessToken, { expires: expireDate });
            this._cookieService.put(this.ACCESS_TOKEN_COOKIE_EXP, '' + this._expiryTime, { expires: expireDate });
            this._cookieService.put(this.REMEMBER_ME, '1', { expires: expireDate });
        }
        else {
            // Create session cookies
            this._cookieService.put(this.ACCESS_TOKEN_COOKIE, accessToken, { expires: '' });
            this._cookieService.put(this.ACCESS_TOKEN_COOKIE_EXP, '' + this._expiryTime, { expires: '' });
            this._cookieService.remove(this.REMEMBER_ME);
        }
        // Let everyone know that if we successfully logged a user in.
        this._isLoggedInSubject.next(true);
    };
    /**
     * Remove all access related cookies.
     */
    CredentialsService.prototype.removeTokens = function () {
        this._cookieService.remove(this.ACCESS_TOKEN_COOKIE_EXP);
        this._cookieService.remove(this.ACCESS_TOKEN_COOKIE);
        this._cookieService.remove(this.REMEMBER_ME);
        // Notify everyone the user is logged out.
        this._isLoggedInSubject.next(false);
    };
    return CredentialsService;
}());
export { CredentialsService };
